import * as React from "react";

import { cn } from "@/lib/utils";
import { underV3, V3_INPUT } from "../v3/flagged";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-xs placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-base",
        className,
        "text-grey-400 bg-tinted-grey-1 border border-tinted-grey-2",
        underV3(V3_INPUT),
      )}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
